import styled from 'styled-components';
import { TFormValues } from '../../App';
import { breakpoints, colors } from '../../constants';
import { Arrow } from '../../svg/Arrow';
import { IOption } from '../../types';
import { createMarkup } from '../../utils';
import { StepContainer } from '../StepContainer';

const Option = styled.div``;
const OptionsContainer = styled.div``;

interface IProps {
    className?: string;
    options: IOption[];
    onStepButtonClick(option: IOption): void;
    setFieldValue(field: keyof TFormValues, value: string): void;
}

const BaseSubjectSelector = ({
    className,
    options,
    onStepButtonClick,
}: IProps) => (
    <StepContainer className={className}>
        <h3>
            Kies je <strong>onderwerp</strong>
        </h3>
        <OptionsContainer>
            {options.map((option) => (
                <Option
                    key={option.title}
                    onClick={() => onStepButtonClick(option)}
                >
                    <span
                        dangerouslySetInnerHTML={createMarkup(
                            option.titleHtml ?? option.title
                        )}
                    />
                    <Arrow />
                </Option>
            ))}
        </OptionsContainer>
    </StepContainer>
);

export const SubjectSelector = styled(BaseSubjectSelector)`
    h3 {
        margin-bottom: 24px;
    }

    ${OptionsContainer} {
        @media (${breakpoints.mediumMin}) {
            display: grid;
            grid-template-columns: 2fr, 3fr;
            grid-template-rows: repeat(4, 36px);
            grid-auto-flow: column;
        }
    }

    ${Arrow} {
        display: none;
    }

    ${Option} {
        position: relative;
        display: flex;
        align-items: center;
        justify-content: space-between;
        transition: all 0.15s linear;
        line-height: 1.3;
        width: fit-content;
        background-color: ${colors.greyLightest};
        padding: 8px 16px 8px 12px;
        margin: 8px 0;
        border-radius: 5px;

        @media (${breakpoints.mediumMin}) {
            background-color: transparent;
            padding: 6px 10px 6px 8px;
            margin: 0;
            border-radius: 0;
            width: fit-content;
            left: -8px;

            ${Arrow} {
                display: block;
                height: 10px;
                fill: transparent;
            }

            span {
                margin-right: 12px;
            }

            :hover {
                cursor: pointer;
                background-color: ${colors.greyLightest};

                ${Arrow} {
                    fill: ${colors.black};
                }
            }
        }
    }
`;
